import dayjs from 'dayjs';
import path from './path';

const removeHtmlMetaTag = (html: string) => {
  return html?.replace(/<meta charset="utf-8">/g, "")
    .replace(/<meta charset="utf-8"\/>/g, "");
}

const removeCssMedia = (css: string) => {
  return css?.replace(/@media[^{]+\{([\s\S]+?})\s*}/g, "");
}

const removeCssFontFace = (css: string) => {
  return css?.replace(/@font-face\s*{\s*([\s\S]+?)\s*}/g, "");
}

const cleanCss = (css: string) => {
  return css;
}

const getPathFromUrl = (url: string) => {
  return url.split("?")[0];
}

const getFileNameFromUrl = (url: string) => {
  return path.parse(url).base;
}

const getExtension = (fileName: string) => {
  return path.extname(fileName);
}

const getExtensionFromUrl = (url: string) => {
  const pathstr = getPathFromUrl(url);
  const fileName = getFileNameFromUrl(pathstr);
  return getExtension(fileName);
}

const getFormatFont = (url: string) => {
  const pathstr = getPathFromUrl(url);
  const fileName = getFileNameFromUrl(pathstr);
  const extension = getExtension(fileName);
  let formatFont: string;
  switch (extension) {
    case ".woff2":
      formatFont = "woff2";
      break;
    case ".woff":
      formatFont = "woff";
      break;
    case ".ttf":
      formatFont = "truetype";
      break;
    case ".otf":
      formatFont = "opentype";
      break;
    case ".eot":
      formatFont = "embedded-opentype";
      break;
    default:
      formatFont = "";
  }
  return formatFont;
}

const formatDateGMTZero = (
  dateValue: any | null,
  stringFormat: string = 'YYYY-MM-DD HH:mm:ss',
) => {
  if (!dateValue) {
    dateValue = dayjs();
  }
  if (!dayjs(dateValue).isValid) return '';
  return dayjs(dateValue).format(stringFormat);
}

const randomString = () => {
  return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
}

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

const isValidFile = (file: File, validExtensions: string[]) => {
  const fileExtension = file.type.split('/')[1]
  return validExtensions.includes(fileExtension)
}

export {
  removeHtmlMetaTag,
  removeCssMedia,
  removeCssFontFace,
  cleanCss,
  getPathFromUrl,
  getFileNameFromUrl,
  getExtension,
  getExtensionFromUrl,
  getFormatFont,
  formatDateGMTZero,
  randomString,
  formatBytes,
  isValidFile,
};